import { tv, type VariantProps } from "@ui/lib/tv";

/**
 * Item chrome shared by ActionPillButton and ActionPillToggleButton. No
 * `hoverColor` default here — the button defaults to yellow, the toggle to
 * pink, each via its own prop default.
 */
export const actionPillItem = tv({
  base: "flex cursor-pointer items-center justify-center rounded-full font-medium text-neutral-600",
  defaultVariants: {
    size: "44",
  },
  variants: {
    hoverColor: {
      pink: "hover:bg-utility-pink-50",
      yellow: "hover:bg-utility-yellow-50",
    },
    size: {
      "32": "flex-auto gap-2 px-3 py-1.5 text-base leading-6 [&_svg]:size-6",
      "44": "flex-1 gap-2 px-4 py-2.5 text-lg leading-6 [&_svg]:size-8",
    },
  },
});

export type ActionPillItemVariants = VariantProps<typeof actionPillItem>;
